import React, { Component } from 'react'
import './ViEditor.css'
import { compose } from 'redux'
import { firestoreConnect, firebaseConnect } from 'react-redux-firebase'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
var CryptoJS = require("crypto-js")
class ViEditor extends Component {
  
    SetTextEditorHeight = (element) =>{  
       element.currentTarget.style.height = (element.currentTarget.scrollHeight - 4) + "px";
    }
    SetTextEditorHeightDirectElement = (element) =>{  
       element.style.height = (element.scrollHeight - 4) + "px";
    }
    state = {fontStyles:["'Courier New', Courier, monospace",
            "'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif",
            "'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif",
            "'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif",
            "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            "'Times New Roman', Times, serif",
            "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif",
            "cursive",
            "Verdana, Geneva, Tahoma, sans-serif",
            "fantasy",
            "monospace"],
            currentFont:0,
            backgroundColors:["#e0cece","#160202","#969a9e","#1077de","#d9d619","#d96319","#1cd919","#7f19d9","#d91919","#d919af","#19ccd9","#191cd9","#3b0303"],
            currentBackgroundColor:0,
            currentFontColor:0,
            date: '', paycut: '', da: '', pass: 'vijay', story: '', holder: new Date(),
            fontStyle:'',fontColor:'',backgroundColor:'',fontWeight:'',textAlign:''}

    InsertText = () =>{
        let TextEditorBox = document.createElement('div')
        TextEditorBox.setAttribute('class','vi-EditorTextBox')
        let TextEditor = document.createElement('textarea')
        TextEditor.setAttribute('class','vi-EditorText') 
        TextEditor.onchange = this.SetTextEditorHeight.bind(TextEditor);
        document.getElementById(this.props.editorId).appendChild(TextEditor);
    } 
    ChangeFontStyle = () =>{
        let nextFontStyle = this.state.currentFont+1;
        if(nextFontStyle >= this.state.fontStyles.length){ nextFontStyle = 0; }
        let element = document.getElementById(this.props.editorId + "Font");
        element.style.fontFamily = this.state.fontStyles[nextFontStyle];
        this.setState({currentFont:nextFontStyle}); 
        this.SetTextEditorHeightDirectElement(element);
    }
    ChangeBackgroundColor = () =>{
        let nextBackgroundColor = this.state.currentBackgroundColor+1;
        if(nextBackgroundColor >= this.state.backgroundColors.length){ nextBackgroundColor = 0; }
        let element = document.getElementById(this.props.editorId);
        element.style.backgroundColor = this.state.backgroundColors[nextBackgroundColor];
        this.setState({currentBackgroundColor:nextBackgroundColor}); 
    }
    ChangeFontColor = () =>{
        let nextBackgroundColor = this.state.currentFontColor+1;
        if(nextBackgroundColor >= this.state.backgroundColors.length){ nextBackgroundColor = 0; }
        let element = document.getElementById(this.props.editorId + "Font");
        element.style.color = this.state.backgroundColors[nextBackgroundColor];
        this.setState({currentFontColor:nextBackgroundColor}); 
    }
    FontBold = ()=>{
        let element = document.getElementById(this.props.editorId + "Font");
        console.log(element.style.fontWeight , element.style.fontWeight == "bold")
        if(element.style.fontWeight == "bold"){
            element.style.fontWeight = "normal";
        }
        else{ element.style.fontWeight = "bold";}
        this.SetTextEditorHeightDirectElement(element);
    } 
    FontAlighLeft = ()=>{
        let element = document.getElementById(this.props.editorId + "Font");
        console.log(element.style.fontWeight , element.style.fontWeight == "bold")
        if(element.style.textAlign == "left"){
            element.style.textAlign = "center";
            document.getElementById('vi-EditorAlignIcon').innerHTML = '<i class="fas fa-align-left    "></i>';
        }
        else{ element.style.textAlign = "left";
        document.getElementById('vi-EditorAlignIcon').innerHTML = '<i class="fas fa-align-center    "></i>';}
    }
    onch = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }
 
    updstory = () => {
        const { firestore } = this.props;
        var story =  this.state.story; //this.state.holder.toString() + '\n' +
        var encrytext = CryptoJS.AES.encrypt(JSON.stringify(story), this.props.keypass).toString();
        let element = document.getElementById(this.props.editorId + "Font");
        if (this.props.aka[0]) {
            var news;
            if (this.props.aka[0].diary) {
                news = {
                    'diary': [{
                        stroy: encrytext,
                        date: new Date().getTime(),
                        editor:'vi-Editor',
                        fontStyle:element.style.fontFamily,
                        fontColor:element.style.color,
                        backgroundColor:element.style.backgroundColor,
                        bold:element.style.fontWeight,
                        textAlign:element.style.textAlign
                    }, ...this.props.aka[0].diary]
                }
            }
            else {
                news = {
                    'diary': [{
                        stroy: encrytext,
                        date: new Date().getTime(),
                        editor:'vi-Editor',
                        fontStyle:element.style.fontFamily,
                        fontColor:element.style.color,
                        backgroundColor:element.style.backgroundColor,
                        bold:element.style.fontWeight,
                        textAlign:element.style.textAlign
                    }]
                }
            }
            firestore.update({ collection: 'flash', doc: this.props.auth.uid }, news).then(() =>
                alert('Updated')

            )
            this.setState({ story: '', holder: new Date(), date: '' })
        }

    }
    updel = () => {
        const { firestore } = this.props;
        const news = this.props.aka[0].diary.filter(i => i.date !== this.state.date);
        var newsupd = {
            'diary': [...news]
        }
        firestore.update({ collection: 'flash', doc: this.props.auth.uid }, newsupd).then(() => alert('Updated'))
    }
    updold = () => {
        var encrytext = CryptoJS.AES.encrypt(JSON.stringify(this.state.story), this.props.keypass).toString();
        const { firestore } = this.props;
        const news = this.props.aka[0].diary.filter(i => i.date !== this.state.date);
        let element = document.getElementById(this.props.editorId + "Font");
        var newsupd = {
            'diary': [{
                stroy: encrytext,
                date: this.state.date,
                editor:'vi-Editor',
                fontStyle:element.style.fontFamily,
                fontColor:element.style.color,
                backgroundColor:element.style.backgroundColor,
                bold:element.style.fontWeight,
                textAlign:element.style.textAlign
            }, ...news]
        }
        firestore.update({ collection: 'flash', doc: this.props.auth.uid }, newsupd).then(() => alert('Updated'))
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.story) {
            if (nextProps.story !== prevState.paycut) {
                var encrytext = CryptoJS.AES.decrypt(nextProps.story, nextProps.keypass);
                var decrytext = JSON.parse(encrytext.toString(CryptoJS.enc.Utf8));
                console.log(nextProps)
                return { story: decrytext, paycut: nextProps.story,holder: new Date(nextProps.data.idataVi.date), date: nextProps.data.idataVi.date,
                    fontColor:nextProps.data.idataVi.fontColor,fontStyle:nextProps.data.idataVi.fontStyle,backgroundColor:nextProps.data.idataVi.backgroundColor,
                    fontWeight:nextProps.data.idataVi.bold,textAlign:nextProps.data.idataVi.textAlign }
            }
            return {}

        }

        else { return null }
    }
    componentDidMount = () =>{
        let element = document.getElementById(this.props.editorId + "Font");
       this.SetTextEditorHeightDirectElement(element)
    }
    componentDidUpdate = () =>{
        let element = document.getElementById(this.props.editorId + "Font");
        this.SetTextEditorHeightDirectElement(element)
    }

  render() {
    return (
        <React.Fragment>
      <div id={this.props.editorId} className='ViEditor' style={{backgroundColor:this.state.backgroundColor}}>
            <div className='vi-EditorBar'>
                <div onClick={this.ChangeFontStyle} className='vi-insertTextIcon'>
                    T
                </div>
                <div onClick={this.ChangeBackgroundColor} className='vi-paintIcon'>
                    <i className="fas fa-paint-roller    "></i>
                </div>
                <div onClick={this.ChangeFontColor} className='vi-insertTextIcon'>
                    C
                </div>
                <div onClick={this.FontBold} className='vi-insertTextIcon'>
                    B
                </div>
                <div id='vi-EditorAlignIcon' onClick={this.FontAlighLeft} className='vi-insertTextIcon'>
                    <i class="fas fa-align-left    "></i>
                </div>
            </div> 
            <div className='vi-EditorTextCard'>
                <div className='vi-EditorTextBox'>
                    <textarea style={{fontFamily:this.state.fontStyle,color:this.state.fontColor,fontWeight:this.state.fontWeight,textAlign:this.state.textAlign}} name='story' id={this.props.editorId +"Font"}  value={this.state.story}   placeholder='Write your feelings...' onChange={(element)=> {this.SetTextEditorHeight(element);this.onch(element);}} className='vi-EditorText'></textarea>
                    <textarea name='holder' onChange={this.onch} value={this.state.holder} className='writektime vi-EditorTime' placeholder='Write your feelings...'></textarea>
                </div>
            </div>
      </div>
      
      {this.state.date === '' ? <button className='savebtn' onClick={this.updstory}>Save</button> :
      <span> 
          <button className='savebtn' onClick={this.updold}>Update</button>
          <button className='savebtn' onClick={this.updel}>Delete</button>
      </span>
        }
        </React.Fragment>
    )
  }
}


ViEditor.proptype = {
    firestore: PropTypes.object.isRequired,
    firebase: PropTypes.object.isRequired
}

const mapStateToProps = state => {
    return {
        aka: state.firestore.ordered.flash,
        auth: state.firebase.auth,
    }
}
const mapDispatchToProps = {
}
export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    firestoreConnect((props) => [{ collection: 'flash', doc: props.auth.uid }]), firebaseConnect()
)(ViEditor)